<ins-panel-group class="panel-wrapper">
    <ng-content></ng-content>
</ins-panel-group>